import { useState, useEffect, useRef } from 'react';

import { Button, Wrapper } from './styles';

const RefreshContent = () => {
  const [refreshed, setRefreshed] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);

  // function that combines setinterval with clearinterval by dan abramov
  const useInterval = (callback, delay) => {
    const savedCallback = useRef();

    // Remember the latest function.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    // eslint-disable-next-line consistent-return
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        const id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  };

  useInterval(() => {
    // Your custom logic here
    if (refreshed) {
      if (timeLeft !== 0) {
        setTimeLeft(timeLeft - 1);
      } else {
        setRefreshed(false);
      }
    }
  }, 1000);

  const refreshOrReload = () => {
    const oReq = new XMLHttpRequest();
    oReq.open('POST', '/__refresh');
    oReq.send();
    setTimeLeft(30);
    setRefreshed(true);
  };
  return (
    <Wrapper>
      <Button onClick={refreshOrReload} type="button">
        {refreshed ? `Reloading... Ready in ${timeLeft}` : 'Refresh content'}
      </Button>
    </Wrapper>
  );
};

export default RefreshContent;
